import { ModuleId } from '@pixacare/forms';

const ceLogoPath = 'assets/icons/ce.svg';
const ce2460LogoPath = 'assets/icons/ce-2460.svg';

export const complianceLogoByModuleId: Record<ModuleId, string | null> = {
  PICTURE_PROVIDER: null,
  TOPOCARE: null,
  WOUNDSIZE: ceLogoPath,
  WOUNDSIZE_LXL: ceLogoPath,
  WOUNDTRACK_II: ce2460LogoPath,
  WOUNDTRACK_II_QUICK: ce2460LogoPath,
  WOUNDTRACK_II_QUICK_INPUTS: ce2460LogoPath,
  WOUNDTRACK_II_QUICK_STUDIO: ce2460LogoPath,
  WOUNDTRACK_INPUTS: ce2460LogoPath,
  USER_IDENTITY: null,
  DRESSFIT: null,
};
